import React from 'react';

const MenuHeader = ({ title, logoUrl, prevSection }) => {


  return (
    <div className="marketing-header-box">
        <button className="back-button" onClick={() => prevSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            {title}
        </button>
         <img src={logoUrl} alt="logo" />
    </div>
  );
};

export default MenuHeader;